import React, { Component } from "react";
import {Control, Form, Errors, Fieldset} from "react-redux-form";
import _ from 'lodash';
import {isRequired, isRfcMoral, required, maxLength, number} from "../field_validations";
import BigFileUpload from "../widgets/big_file_upload";

export default class TracingAgreementsForm extends Component {
	render () {
		const { match , municipalities, agreements } = this.props;
		//let agreementsRevAdmin = agreements.revisions ? _.find(agreements.revisions,{project_version_phase:{version_phase:{phase: {slug: 'project-agency-fiscal-entity-admin'}}}}):undefined
		let agreementsRevAdmin = agreements.revisions ? _.find(agreements.revisions,{version_phase:{phase: {slug: 'revision-project-agreements-agency-admin'}}, project_version_phase:{version_phase:{phase: {slug: 'project-agreements-agency'}}}}):undefined
		let agreementsRevLegal = agreements.revisions ? _.find(agreements.revisions,{version_phase:{phase: {slug: 'revision-project-agreements-agency-legal'}}, project_version_phase:{version_phase:{phase: {slug: 'project-agreements-agency'}}}}):undefined
		//console.log('revisions===>', agreements.revisions);
		//console.log('agreementsRevAdmin===>', agreementsRevAdmin);//revision-project-agreements-agency-admin
		//console.log('agreementsRevLegal===>', agreementsRevLegal);//revision-project-agreements-agency-legal
		//info data
		let ef= !_.isEmpty(agreementsRevAdmin) ? _.find(agreementsRevAdmin.body, {field: 'entity_fiscal'}) : undefined;
		let bd= !_.isEmpty(agreementsRevAdmin) ? _.find(agreementsRevAdmin.body, {field: 'bank_data'}) : undefined;

		return (
			<div className="columns is-centered">
				<div className="column is-10">
					<Form model="agreements.data" onSubmit={(values => this._handleSubmit(values))}>
						<fieldset className="fieldset">
							<legend>Datos del proyecto</legend>

							<div className="field">
								<div className="control">
									<label htmlFor="name" className="label">Nombre de la instancia</label>
									<p>{!_.isEmpty(agreements.data) && !_.isEmpty(agreements.data.agency) ? agreements.data.agency.name: '---'}</p>
								</div>
							</div>

							<div className="field">
								<div className="control">
									<label htmlFor="name" className="label">Nombre del proyecto</label>
									<p>{!_.isEmpty(agreements.data) ? agreements.data.name: '---'}</p>
								</div>
							</div>

							<div className="field is-grouped">
								<div className="control is-expanded">
									<label htmlFor="version_id" className="label">Año</label>
									<p>{!_.isEmpty(agreements.data) && !_.isEmpty(agreements.data.agency) && !_.isEmpty(agreements.data.agency.version) ? agreements.data.agency.version.year : '---'}</p>
								</div>

								<div className={`control is-expanded${agreements.isFetching ? ' is-loading' : ''}`}>
									<label className="label">Entidad</label>
									<p>{!_.isEmpty(agreements.data) && !_.isEmpty(agreements.data.agency) ? agreements.data.agency.agenciable.name : '---'}</p>
								</div>

								<div className={`control is-expanded${agreements.isFetching ? ' is-loading' : ''}`}>
									<label className="label">Naturaleza jurídica</label>
									<p>{!_.isEmpty(agreements.data) && !_.isEmpty(agreements.data.agency) ? agreements.data.agency.legal_nature: '---'}</p>
								</div>
							</div>
						</fieldset>

						{match.params.modality ==='modalidad-i' ?
							ef && !_.isEmpty(ef.comment) ?
								<div className={`message is-${ef.status}`}>
									<div className="message-header">Comentarios</div>
									<div className="message-body">
										<p>{ef.comment}</p>
									</div>
								</div>
								: ''
							:''}

						{match.params.modality ==='modalidad-i' ?
							<Fieldset model=".agency.fiscal_entity" className="fieldset">
								<legend>DATOS DE LA TESORERÍA O DEPENDENCIA HOMOLOGA DE LA ENTIDAD FEDERATIVA</legend>

								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor="name" className="label">Nombre <span className="small has-text-danger">*</span></label>
										<Control.text model=".name" id="name" className={`input${ef && ef.status ? ` is-${ef.status}`:''}`} placeholder="Nombre" errors={{isRequired}} validateOn="change" disabled={this._blockFields(ef && ef.allow_edit ? ef.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El campo es obligatoria'}} />
									</div>

									<div className="control">
										<label htmlFor="rfc" className="label">RFC<span className="small has-text-danger">*</span></label>
										<Control.text model=".rfc" id="rfc" className={`input${ef && ef.status ? ` is-${ef.status}`:''}`} errors={{isRequired, isRfcMoral}} validateOn="change" placeholder="RFC" disabled={this._blockFields(ef && ef.allow_edit ? ef.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".rfc" show="touched" wrapper={(props) => <small className="help has-text-danger">{props.children}</small>} messages={{isRequired: 'El RFC es obligatorio. ', isRfc: 'RFC inválido. '}} />
									</div>
								</div>

								<div className="field is-grouped">
									<div className="control">
										<label htmlFor="municipality_id" className="label">Municipio <span className="small has-text-danger">*</span></label>
										<div className={`select${ef && ef.status ? ` is-${ef.status}`:''}${municipalities.isFetching ? ' is-loading':''}`}>
											<Control.select model=".municipality_id" id="municipality_id" className="select" errors={{required}} validateOn="change" disabled={this._blockFields(ef && ef.allow_edit ? ef.allow_edit:undefined,agreements.editable)}>
												<option value=" " defaultValue>--- Municipio ---</option>
												{_.map(municipalities.list,(mun, k) => {
													return <option value={mun.id} key={k}>{mun.name}</option>
												})}
											</Control.select>
										</div>
										<Errors model=".municipality_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El municipio es obligatorio'}} />
									</div>

									<div className="control">
										<label htmlFor="cp" className="label">Código postal <span className="small has-text-danger">*</span></label>
										<Control.text model=".cp" type="text" id="cp" className={`input${ef && ef.status ? ` is-${ef.status}`:''}`} placeholder="Código postal" errors={{isRequired}} validateOn="change" disabled={this._blockFields(ef && ef.allow_edit ? ef.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".cp" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El código postal es obligatorio'}} />
									</div>

									<div className="control is-expanded">
										<label htmlFor="colony" className="label">Colonia <span className="small has-text-danger">*</span></label>
										<Control.text model=".colony" id="colony" className={`input${ef && ef.status ? ` is-${ef.status}`:''}`} placeholder="Colonia" errors={{isRequired}} validateOn="change" disabled={this._blockFields(ef && ef.allow_edit ? ef.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".colony" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'La colonia es obligatoria'}} />
									</div>
								</div>

								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor="street" className="label">Dirección <span className="small has-text-danger">*</span></label>
										<Control.text model=".street" id="street" className={`input${ef && ef.status ? ` is-${ef.status}`:''}`} placeholder="Calle" errors={{isRequired}} validateOn="change" disabled={this._blockFields(ef && ef.allow_edit ? ef.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".street" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'La dirección es obligatoria'}} />
									</div>

									<div className="control">
										<label htmlFor="num_ext" className="label">Número exterior<span className="small has-text-danger">*</span></label>
										<Control.text model=".num_ext" id="num_ext" className={`input${ef && ef.status ? ` is-${ef.status}`:''}`} errors={{required}} validateOn="change" placeholder="Número exterior" disabled={this._blockFields(ef && ef.allow_edit ? ef.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".num_ext" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El número exterior es obligatorio'}} />
									</div>

									<div className="control">
										<label htmlFor="num_int" className="label">Número Interior </label>
										<Control.text model=".num_int" type="text" id="num_int" className={`input${ef && ef.status ? ` is-${ef.status}`:''}`} placeholder="Número interior" disabled={this._blockFields(ef && ef.allow_edit ? ef.allow_edit:undefined,agreements.editable)}/>
									</div>
								</div>
							</Fieldset>
							:''}

						{match.params.modality ==='modalidad-i' ?
							bd && !_.isEmpty(bd.comment) ?
								<div className={`message is-${bd.status}`}>
									<div className="message-header">Comentarios</div>
									<div className="message-body">
										<p>{bd.comment}</p>
									</div>
								</div>
								: ''
							:''}

						{match.params.modality ==='modalidad-i' ?
							<Fieldset model=".agency.fiscal_entity" className="fieldset">
								<legend>datos bancarios</legend>

								<div className="field is-grouped">
									<div className="control">
										<label htmlFor="bank_name" className="label">Nombre de banco <span className="small has-text-danger">*</span></label>
										<Control.text model=".bank_name" id="bank_name" className={`input${bd && bd.status ? ` is-${bd.status}`:''}`} placeholder="Nombre de banco" errors={{isRequired}} validateOn="change" disabled={this._blockFields(bd && bd.allow_edit ? bd.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".bank_name" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El campo es obligatoria'}} />
									</div>

									<div className="control">
										<label htmlFor="bank_account" className="label">Número de cuenta <span className="small has-text-danger">*</span></label>
										<Control.text model=".bank_account" id="bank_account" className={`input${bd && bd.status ? ` is-${bd.status}`:''}`} placeholder="Número de cuenta" errors={{isRequired, maxLength: maxLength(14)}} validateOn="change" disabled={this._blockFields(bd && bd.allow_edit ? bd.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".bank_account" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El campo es obligatoria', maxLength: 'La cuenta no debe ser mayor a 14 caracteres'}} />
									</div>

									<div className="control">
										<label htmlFor="bank_office_num" className="label">Número de sucursal <span className="small has-text-danger">*</span></label>
										<Control.text model=".bank_office_num" id="bank_office_num" className={`input${bd && bd.status ? ` is-${bd.status}`:''}`} placeholder="Número de sucursal" errors={{isRequired, maxLength: maxLength(5)}} validateOn="change" disabled={this._blockFields(bd && bd.allow_edit ? bd.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".bank_office_num" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El campo es obligatoria' , maxLength: 'El numero no debe ser mayor a 5 caracteres'}} />
									</div>
								</div>

								<div className="field">
									<div className="control">
										<label htmlFor="bank_clabe" className="label">Clave bancaria estandarizada(CLABE 18 digitos) <span className="small has-text-danger">*</span></label>
										<Control.text model=".bank_clabe" id="bank_clabe" className={`input${bd && bd.status ? ` is-${bd.status}`:''}`} placeholder="CLABE 18 digitos" errors={{isRequired, maxLength: maxLength(18), number}} validateOn="change" disabled={this._blockFields(bd && bd.allow_edit ? bd.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".bank_clabe" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El campo es obligatoria', maxLength: 'La CLABE debe ser de 18 digitos', number: 'Solo son permitidos numeros'}} />
									</div>
								</div>

								<div className="field is-grouped">
									<div className="control">
										<label htmlFor="bank_municipality_id" className="label">Municipio <span className="small has-text-danger">*</span></label>
										<div className={`select${bd && bd.status ? ` is-${bd.status}`:''}${municipalities.isFetching ? ' is-loading':''}`}>
											<Control.select model=".bank_municipality_id" id="bank_municipality_id" className="select" errors={{required}} validateOn="change" disabled={this._blockFields(bd && bd.allow_edit ? bd.allow_edit:undefined,agreements.editable)}>
												<option value=" " defaultValue>--- Municipio ---</option>
												{_.map(municipalities.list,(mun, k) => {
													return <option value={mun.id} key={k}>{mun.name}</option>
												})}
											</Control.select>
										</div>
										<Errors model=".bank_municipality_id" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El municipio es obligatorio'}} />
									</div>

									<div className="control">
										<label htmlFor="bank_cp" className="label">Código postal <span className="small has-text-danger">*</span></label>
										<Control.text model=".bank_cp" type="text" id="bank_cp" className={`input${bd && bd.status ? ` is-${bd.status}`:''}`} placeholder="Código postal" errors={{isRequired}} validateOn="change" disabled={this._blockFields(bd && bd.allow_edit ? bd.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".bank_cp" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'El código postal es obligatorio'}} />
									</div>

									<div className="control is-expanded">
										<label htmlFor="bank_colony" className="label">Colonia <span className="small has-text-danger">*</span></label>
										<Control.text model=".bank_colony" id="bank_colony" className={`input${bd && bd.status ? ` is-${bd.status}`:''}`} placeholder="Colonia" errors={{isRequired}} validateOn="change" disabled={this._blockFields(bd && bd.allow_edit ? bd.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".bank_colony" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'La colonia es obligatoria'}} />
									</div>
								</div>

								<div className="field is-grouped">
									<div className="control is-expanded">
										<label htmlFor="bank_street" className="label">Dirección de la sucursal <span className="small has-text-danger">*</span></label>
										<Control.text model=".bank_street" id="bank_street" className={`input${bd && bd.status ? ` is-${bd.status}`:''}`} placeholder="Calle" errors={{isRequired}} validateOn="change" disabled={this._blockFields(bd && bd.allow_edit ? bd.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".bank_street" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ isRequired: 'La dirección es obligatoria'}} />
									</div>

									<div className="control">
										<label htmlFor="bank_num_ext" className="label">Número exterior <span className="small has-text-danger">*</span></label>
										<Control.text model=".bank_num_ext" id="bank_num_ext" className={`input${bd && bd.status ? ` is-${bd.status}`:''}`} errors={{required}} validateOn="change" placeholder="Número exterior" disabled={this._blockFields(bd && bd.allow_edit ? bd.allow_edit:undefined,agreements.editable)}/>
										<Errors model=".bank_num_ext" show="touched" wrapper={(props)=> <small className="help has-text-danger">{props.children}</small>} messages={{ required: 'El número exterior es obligatorio'}} />
									</div>

									<div className="control">
										<label htmlFor="bank_num_int" className="label">Número Interior </label>
										<Control.text model=".bank_num_int" type="text" id="bank_num_int" className={`input${bd && bd.status ? ` is-${bd.status}`:''}`} placeholder="Número interior" disabled={this._blockFields(bd && bd.allow_edit ? bd.allow_edit:undefined,agreements.editable)}/>
									</div>
								</div>
							</Fieldset>
							:''}

						<Fieldset model=".documents" className="fieldset">
							<legend>Documentación</legend>
							<div className="field is-grouped is-grouped-multiline is-grouped-left">
								{_.map(_.filter(agreements.documents_items, (o) => {return (o.modality_id === null || o.modality_id === (agreements.data ? agreements.data.modality_id:undefined))}),(item, d) => {
									let documentRev = undefined;
									documentRev = !_.isEmpty(agreementsRevAdmin) ? _.find(agreementsRevAdmin.body, {field: item.slug}):undefined;
									if(_.isEmpty(documentRev)){
										documentRev =!_.isEmpty(agreementsRevLegal) ? _.find(agreementsRevLegal.body, {field: item.slug}):undefined;
									}
									let accepts = undefined;
									_.map(item.documents_types, (ext) => {
										accepts = accepts ? `${accepts},${ext.extensions}`:`${ext.extensions}`
									})
									//console.log(`document: ${item.slug}===>`, agreements.data && agreements.data.documents && agreements.data.documents[item.slug]);
									return (
										<BigFileUpload
											key={d}
											model={`.${item.slug}`}
											name={item.name}
											file={agreements.data && agreements.data.documents && agreements.data.documents[item.slug]}
											file_format={item.file_format}
											accept={accepts}
											comment={documentRev && documentRev.comment ? documentRev.comment:undefined}
											status={documentRev && documentRev.status}
											disabled={this._blockFields(documentRev && documentRev.allow_edit ? documentRev.allow_edit:undefined, agreements.editable)}
										/>
									)
								})}
							</div>
						</Fieldset>

						<div className="message is-success">
							<div className="message-body">
								<div className="field">
									<div className="control">
										<label htmlFor="finished" className="checkbox" disabled={this._permissionSave()}>
											<Control.checkbox model=".finished" id="finished" className="checkbox" disabled={this._permissionSave()}/>
											<span style={{whiteSpace:'normal'}}>{`He concluido y certifico que la información proporcionada es correcta y completa; conozco las disposiciones establecidas en las Reglas de Operación del PFTPG ${agreements.version ? agreements.version.year:'----'} y su Acuerdo Modificatorio.`}</span>
										</label>
									</div>
								</div>
							</div>
						</div>

						{match.params.modality ==='modalidad-i' ?
							<div className="field is-grouped">
								<div className="control">
									<button className="button is-info" type="button" onClick={() => this.props.projectAgreementsExport(match.params.modality, match.params.state, match.params.municipality)}>
										<span className="icon"><i className="fa fa-link" /></span>
										<span>Generar carta de confirmación de datos bancarios</span>
									</button>
								</div>
							</div>
							:''}

						<div className="field is-grouped is-grouped-right">
							<div className="control">
								<button type="button" className="button is-large" onClick={() => this.props.history.push('/inicio')}>Regresar</button>
							</div>

							<div className="control">
								<Control.button model="agreements.data" className="button is-large is-primary" disabled={this._permissionSave()}>Guardar</Control.button>
							</div>
						</div>
						<p className="has-text-grey has-text-right is-small">Los campos indicados con <span className="small has-text-danger">*</span> son obligatorios.</p>
					</Form>
				</div>
			</div>
		)
	}

	componentWillMount(){
		let {match, agreements} = this.props;
		let {modality} = match.params;
		if(!_.isEmpty(agreements.data) && !_.isEmpty(agreements.data.agency)){
			if(modality ==='modalidad-i' || modality ==='modalidad-iii'){
				this.props.fetchMunicipalities(agreements.data.agency.agenciable_id);
			}else {
				this.props.fetchMunicipalities(agreements.data.agency.agenciable.state_id);
			}
		}
	}

	_handleSubmit(values){
		const { state, municipality, modality } = this.props.match.params;
		this.props.projectAgreementsSave(modality, state, municipality, values);
		//console.log('values: ',values);
	}

	_blockFields(allow, editable) {
		if(allow){
			if(allow==='true' && editable){
				return false;
			}else {
				return true;
			}
		}else {
			return !editable;
		}
	}

	_permissionSave(){
		const { agreements } = this.props;
		if(agreements.editable){
			return false;
		}else {
			return true;
		}
	}
}


// WEBPACK FOOTER //
// ./src/elements/tracing/agreements.jsx